module.exports = __webpack_public_path__ + "static/media/buckets-icon.2312e392.svg";